/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssignmentType {
    Broker = 0,
    Driver = 1,
}
